export default __webpack_public_path__ + "static/media/EnergyStorage.aed001b9.jpg";